import React from "react";
import { Form } from "react-bootstrap";

/**
 * Checkbox list of classes. Empty selection = "All classes".
 */
const ClassMultiSelect = ({ classes = [], value = [], onChange }) => {
  const toggle = (id) =>
    onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <small className="text-muted">
          {value.length === 0 ? "Applies to all classes" : `${value.length} class(es) selected`}
        </small>
        {value.length > 0 && (
          <button type="button" className="btn btn-link btn-sm p-0" onClick={() => onChange([])}>
            Clear (all classes)
          </button>
        )}
      </div>
      <div
        className="border rounded p-2"
        style={{ maxHeight: 180, overflowY: "auto", display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))" }}
      >
        {classes.map((c) => (
          <Form.Check
            key={c.id}
            id={`cls-${c.id}`}
            type="checkbox"
            label={c.class_name || c.classname}
            checked={value.includes(c.id)}
            onChange={() => toggle(c.id)}
          />
        ))}
        {classes.length === 0 && <small className="text-muted">No active classes</small>}
      </div>
    </div>
  );
};

export default ClassMultiSelect;
